module.exports = __webpack_public_path__ + "static/media/shares.133490d7.svg";